import React from "react";

/**
 * returns the jsx component if it is a functional component or a styled component
 * or returns the ReactNode
 * @param Component
 * @returns undefined if the component is undefined
 * @returns the component if it is a functional component or a styled component
 * @returns the ReactNode if it is not a functional component or a styled component
 */
export const getComponent = (Component: React.FC | React.ReactNode) => {
    if (!Component) return undefined;
    const compIsFC =
        typeof Component === "function" || (typeof Component === "object" && Object.keys(Component).includes("render"));
    //@ts-expect-error no constructs or call signatures error. Not a true error if it's a functional/styled component, which we check for.
    return compIsFC ? <Component /> : Component;
};

/**
 * Get the text(only) content from React.Children.
 * For example, both <div>something</div> and <div><span>something</span></div> will return "something".
 * If you tried to use just children.toString on the second example, you would get '[object Object]'.
 *
 * @param children
 */
export const getTextContent = (children: React.ReactNode): string => {
    let text = "";

    React.Children.forEach(children, (child) => {
        if (typeof child === "string" || typeof child === "number" || typeof child === "boolean") {
            text += child;
        } else if (child instanceof Array) {
            text += child.map(getTextContent).join("");
        } else if (React.isValidElement(child)) {
            // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment,@typescript-eslint/no-unsafe-member-access
            const propsChildren = child.props.children;
            if (propsChildren) {
                // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
                text += getTextContent(propsChildren);
            }
        }
    });

    return text;
};
